import { render, staticRenderFns } from "./SettingHatchery.vue?vue&type=template&id=3aa2f630&scoped=true&"
import script from "./SettingHatchery.vue?vue&type=script&lang=js&"
export * from "./SettingHatchery.vue?vue&type=script&lang=js&"
import style0 from "./SettingHatchery.vue?vue&type=style&index=0&id=3aa2f630&lang=scss&scoped=true&"
import style1 from "./SettingHatchery.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa2f630",
  null
  
)

export default component.exports